import { render, staticRenderFns } from "./VersionUpgrade.vue?vue&type=template&id=1f19d182&scoped=true"
import script from "./VersionUpgrade.vue?vue&type=script&lang=js"
export * from "./VersionUpgrade.vue?vue&type=script&lang=js"
import style0 from "./VersionUpgrade.vue?vue&type=style&index=0&id=1f19d182&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f19d182",
  null
  
)

export default component.exports